//TODO:  Do we need substate for this Task Object State???   Split into SubState like Contract?

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppService } from '@Core/services/proprietary/app.service';
import { StateHelperService } from '@Core/services/proprietary/state-helper.service';
import { cloneDeep } from 'src/ep-utils';
import { DocumentObjectDefaults } from './document-object.defaults';
import {
    AddFiling,
    DeleteDocument,
    DeleteFiling,
    DeleteNewFilings,
    ResetState,
    SetDocuments,
    UpdateDocument,
    UpdateFiling,
    UpdateFilingReferences
} from './multidocument-object.actions';

export interface MultiDocumentObjectStateModel {
    currentDocID: string;
    entities: any;
    documents: any;
    filing: any;
    tasks: any;
}

const MultiDocumentObjectStateDefaults: MultiDocumentObjectStateModel = {
    currentDocID: null,
    entities: {},
    documents: {},
    filing: {},
    tasks: {}
};

@State<MultiDocumentObjectStateModel>({
    name: 'multiDocumentObjectState',
    defaults: MultiDocumentObjectStateDefaults
})
@Injectable()
export class MultiDocumentObjectState {
    constructor(private app: AppService, private helper: StateHelperService) { }

    @Selector()
    static entities(state: MultiDocumentObjectStateModel) {
        let tempEntities = { ...state.entities };
        tempEntities.Documents = state.documents;
        tempEntities.Filing = state.filing;
        return tempEntities;
    }

    @Selector()
    static document(state: MultiDocumentObjectStateModel) {
        return state.documents[state.currentDocID] || null;
    }

    @Selector()
    static documents(state: MultiDocumentObjectStateModel) {
        let result = [];
        for (let i in state.documents) {
            result.push(state.documents[i]);
        }
        return result;
    }

    @Selector()
    static documentByID(state: MultiDocumentObjectStateModel) {
        return (docID: string) => {
            if (docID) {
                for (var i in state.documents) {
                    if (state.documents[i].Doc_ID == docID) {
                        return state.documents[i];
                    }
                }
            }
            return {};
        };
    }

    @Selector()
    static filings(state: MultiDocumentObjectStateModel) {
        let result = [];
        for (var i in state.filing) {
            result.push(state.filing[i]);
        }
        return result;
    }

    // Actions
    @Action(SetDocuments)
    setDocuments(sc: StateContext<MultiDocumentObjectStateModel>, action: SetDocuments) {
        const state = sc.getState();

        let docObj = {};
        for (var i in action.documents) {
            let currDoc = action.documents[i];
            docObj[currDoc.Doc_ID] = currDoc;
        }

        sc.patchState({
            documents: docObj
        });
    }

    @Action(UpdateDocument)
    updateDocument(sc: StateContext<MultiDocumentObjectStateModel>, action: UpdateDocument) {
        const state = sc.getState();
        const docID = action.document.Doc_ID;
        if (!docID) {
            return;
        }
        const currentDoc = state.documents[docID];
        let updateDoc: any = { ...action.document }; //need DEEP copy?

        sc.patchState({
            documents: {
                ...state.documents,
                [docID]: { ...state.documents[docID], ...updateDoc }
            }
        });
    }

    @Action(DeleteDocument)
    deleteDocument(sc: StateContext<MultiDocumentObjectStateModel>, action: DeleteDocument) {
        const state = sc.getState();
        const docID = action.docID;
        if (!docID) {
            return;
        }
        let docs = { ...state.documents };

        for (const i in docs) {
            if (docs[i].Doc_ID === docID) {
                delete docs[i];
            }
        }

        sc.patchState({
            documents: docs
        });
    }

    @Action(UpdateFiling)
    updateFiling(sc: StateContext<MultiDocumentObjectStateModel>, action: UpdateFiling) {
        const state = sc.getState();
        let docLinkID = action.filing.DocLink_ID;
        let updateFiling: any = { ...action.filing };

        sc.patchState({
            filing: {
                ...state.filing,
                [docLinkID]: {
                    ...state.filing[docLinkID],
                    ...updateFiling
                }
            }
        });
    }

    @Action(AddFiling)
    addFiling(sc: StateContext<MultiDocumentObjectStateModel>, action: AddFiling) {
        const state = sc.getState();
        let newFilingID: any = this.helper.getTempID();
        let newFiling = this.helper.createDefaultItem(DocumentObjectDefaults, 'Filing', action.filing);
        this.helper.setItemAdded(newFiling);
        newFiling.DocLink_ID = newFilingID;

        sc.patchState({
            filing: { ...state.filing, [newFilingID]: newFiling }
        });
    }

    @Action(DeleteFiling)
    deleteFiling(sc: StateContext<MultiDocumentObjectStateModel>, action: DeleteFiling) {
        const state = sc.getState();

        let document = { ...state.documents[state.currentDocID] };
        if (!document.Filing) {
            document.Filing = [];
        }

        let filing = cloneDeep(state.filing);

        for (var i in filing) {
            if (filing[i].Edit_Status === 'A') {
                document.Filing = this.helper.removeArrayItemByValue(document.Filing, i);
                delete filing[i];
            }
        }

        sc.patchState({
            filing: filing,
            documents: { ...state.documents, [state.currentDocID]: document }
        });
    }

    @Action(DeleteNewFilings)
    deleteNewFilings(sc: StateContext<MultiDocumentObjectStateModel>, action: DeleteNewFilings) {
        const state = sc.getState();
        let documents = { ...state.documents };
        let filing = cloneDeep(state.filing);

        for (var i in filing) {
            if (filing[i].Edit_Status === 'A') {
                for (const x in documents) {
                    let document = { ...documents[x] };
                    if (!document.Filing) {
                        document.Filing = [];
                    }

                    document.Filing = this.helper.removeArrayItemByValue(document.Filing, i);

                    documents[document.Doc_ID] = document;
                }

                delete filing[i];
            }
        }

        sc.patchState({
            filing: filing,
            documents: documents
        });
    }

    @Action(UpdateFilingReferences)
    updateFilingReferences(sc: StateContext<MultiDocumentObjectStateModel>, action: UpdateFilingReferences) {
        const state = sc.getState();
        let filing = cloneDeep(state.filing);

        for (var i in filing) {
            if (filing[i].Edit_Status === 'A') {
                filing[i] = { ...filing[i], ...action.filingTemplate };
            }
        }

        sc.patchState({
            filing: filing
        });
    }

    @Action(ResetState)
    resetState(sc: StateContext<MultiDocumentObjectStateModel>, action: ResetState) {
        sc.setState({
            currentDocID: null,
            entities: {},
            documents: {},
            filing: {},
            tasks: {}
        });
    }
}
